/**
 * Secciones del Resumen: cuáles se ven y en qué orden (puro). Cada persona guarda su preferencia en su cuenta;
 * las secciones nuevas que no estén en una preferencia guardada aparecen al final, visibles.
 */
export interface HomeSection { id: string; on: boolean }

export const HOME_SECTIONS: ReadonlyArray<{ id: string; label: string; hint: string; half?: boolean }> = [
  { id: 'savings', label: 'Ahorro del mes', hint: 'Ingresos, gastos, tasa de ahorro y frente a tu media' },
  { id: 'expenses', label: 'Gastos por categoría', hint: 'Frente a lo normal, con la nota o el motivo' },
  { id: 'accounts', label: 'Cuentas', hint: 'Saldos, si cuadran con el banco y cargos fijos que faltan' },
  { id: 'income', label: 'Ingresos por categoría', hint: '' },
  { id: 'networth', label: 'Patrimonio', hint: 'Total, liquidez e inversiones', half: true },
  { id: 'investments', label: 'Inversiones', hint: 'Valor, aportado y rentabilidad', half: true },
  { id: 'recent', label: 'Últimos movimientos', hint: '' },
  { id: 'budget', label: 'Presupuesto del mes', hint: 'Cuánto llevas de cada categoría con presupuesto' },
];

export const DEFAULT_HOME: HomeSection[] = HOME_SECTIONS.map(s => ({ id: s.id, on: true }));

export function normalizeHome(saved: unknown): HomeSection[] {
  const known = new Set(HOME_SECTIONS.map(s => s.id));
  const out: HomeSection[] = [];
  if (Array.isArray(saved)) for (const x of saved) {
    const id = String((x as HomeSection)?.id ?? '');
    if (known.has(id) && !out.some(o => o.id === id)) out.push({ id, on: (x as HomeSection).on !== false });
  }
  for (const s of DEFAULT_HOME) if (!out.some(o => o.id === s.id)) out.push({ ...s });
  return out;
}

export function moveSection(layout: HomeSection[], id: string, delta: -1 | 1): HomeSection[] {
  const i = layout.findIndex(s => s.id === id), j = i + delta;
  if (i < 0 || j < 0 || j >= layout.length) return layout;
  const next = layout.slice();
  [next[i], next[j]] = [next[j]!, next[i]!];
  return next;
}
